import { StyledInfoBox } from './showpad-delay-info-box.style';
import { Text } from '../../ui-components/text/text';

type ShowpadDelayInfoBoxProps = {
    text: string; 
    withoutPadding?: boolean;
};

export const ShowpadDelayInfoBox = (props: ShowpadDelayInfoBoxProps) => {
    return (
        <div>
            <StyledInfoBox withoutPadding={props.withoutPadding}>
                <svg style={{ 'flex-shrink': 0 }} width="2rem" height="2rem" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="Warning / Info"> <path id="Vector" d="M12 11V16M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21ZM12.0498 8V8.1L11.9502 8.1002V8H12.0498Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g> </g></svg>
                <Text
                    fontSize='footerSmall'
                    fontStyle='italic'
                >
                    {props.text}
                </Text>
            </StyledInfoBox>
        </div>
    );
};

